export { LoyaltyCardComponent } from './loyalty-card';
